<template>
  <div>
    <!-- Main content -->
    <div id="js-carousel-productgroup" class="carousel-product carousel slide carousel-fade items-1" v-if="product.file_id">
      <a class="close-popup" v-on:click="closePopup"><span class="fa fa-fw fa-close"></span></a>
      <div class="carousel-inner" role="listbox">
        <div class="js-carousel-image item active">
          <div class="js-carousel-product-image carousel-item-image" :style="'background-image: url(' + baseDomain + productShopId + '/largefiles/' + product.file_id + '.' + product.file_ext + ');'"><div class="js-carousel-product-printimage carousel-item-printimage visible-print-block"><img :src="baseDomain + productShopId + '/largefiles/' + product.file_id + '.' + product.file_ext" /></div></div>
        </div>
      </div>
      <div class="carousel-title js-carousel-productname big-text" v-if="!titleBelowImage">
        <h1>{{ $filters.marketingname(product) }}</h1>
        <div class="ratings hidden-print" v-if="isMovieLike">
          <span :class="'rating-icon rating-' + r" v-for="r in allRatings"></span>
        </div>
        <div class="col-xs-12 tags" v-if="tags.length">
          <span class="label label-info tag" v-for="tag in tags">{{ tag }}</span>
        </div>
      </div>
      <div class="product-showimages-button product-showtrailer-button" v-if="hasTrailer">
        <a class="btn btn-success" :href="trailerUrl" target="_blank"><span class="fa fa-fw fa-play"></span><span class="button-text">{{ _('Show trailer') }}</span></a>
      </div>
      <div class="product-showimages-button" v-if="false">
        <a class="btn btn-success store-lightbox-link" :href="baseDomain + productShopId + '/largefiles/' + product.file_id + '.' + product.file_ext"><span class="fa fa-fw fa-image"></span><span class="button-text">{{ _('View large images') }}</span> <span class="button-count" v-if="product.sharedFile.length">{{ '(' + (product.sharedFile.length + 1) + ')' }}</span></a>
      </div>
    </div>
    <div id="js-header-product" :class="'page-header-bar product-header-bar text-center' + (product.file_id ? ' has-image' : '')" v-if="(titleBelowImage || !product.file_id)">
      <a class="close-popup" v-on:click="closePopup"><span class="fa fa-fw fa-close"></span></a>
      <div class="js-page-name page-header-title big-text">
        <div class="not-container">
          <h1>{{ $filters.marketingname(product) }}</h1>
          <div class="ratings hidden-print" v-if="isMovieLike">
            <span :class="'rating-icon rating-' + r" v-for="r in allRatings"></span>
          </div>
        </div>
      </div>
	  </div>
    <div class="main-content popup-content">
      <div class="row product-content-mainwrap">
        <div class="product-content-main product-content-text text-content col-xs-12" v-if="product.channeldata || product.description" v-html="sanitizeHtml(product.channeldata?.description ? product.channeldata.description : product.description)"></div>
      </div>
      <product-movie :product="product" :baseDomain="baseDomain" :shopId="productShopId" v-if="isMovie"></product-movie>
      <product-general :product="product" :baseDomain="baseDomain" :shopId="productShopId" v-else></product-general>
      <product-properties :product="product" :baseDomain="baseDomain" :shopId="productShopId"></product-properties>
      <product-connections :product="product" :baseDomain="baseDomain" :shopId="productShopId"></product-connections>
      <product-distances :product="product" :baseDomain="baseDomain" :shopId="productShopId"></product-distances>
      <product-enquiries v-if="!hideMerchant" :product="product" :baseDomain="baseDomain" :shopId="productShopId" :locale="locale"></product-enquiries>
      <template v-if="showLinkedProducts && upsellProducts.length">
        <h4 style="margin: -15px 15px -15px 15px">{{ upsellTitle }}</h4>
        <div class="linked-products flex-card-items">
          <PopupProductItem v-for="(prod, index) in upsellProducts" :key="prod.id" :shopId="shopId" :productShopId="productShopId" :settings="settings" :product="prod.product" :baseDomain="baseDomain" v-on:itemClick="upsellProductClick"></PopupProductItem>
        </div>
      </template>
      <div id="js-product-map" class="product-content-map" v-if="false && hasCoordinates"></div>
    </div>
    <div class="product-content-allimages">
      <ul id="js-product-images" class="product-content-allimageslist list-unstyled lightSlider">
        <li v-for="image in product.sharedFile"><span class="store-lightbox-link" :data-href="baseDomain + productShopId + '/largefiles/' + image.id + '-' + encodeURI(image.filename)" :style="{ backgroundImage: 'url(\'' + baseDomain + productShopId + '/files/' + image.id + '-' + encodeURI(image.filename) + '\')' }"><img class="img-responsive visible-print" :src="baseDomain + productShopId + '/files/' + image.id + '-' + encodeURI(image.filename)" /></span></li>
      </ul>
    </div>
    <div class="popup-footer modal-footer" v-if="showFooter">
      <template v-if="context === 'productlibrary'">
        <button class="btn btn-default" @click="closePopup()">{{ _('Close') }}</button>
        <a class="btn btn-primary" :href="previewProductUrl" target="_blank"><i class="fa fa-fw fa-globe"></i> {{ _('Preview') }}</a>
        <button class="btn btn-success" @click="triggerAction()"><i class="fa fa-fw fa-check"></i> {{ _('Select') }}</button>
      </template>
    </div>
  </div>
</template>

<style scoped>
.popup-content .row {
  margin-left: 0;
  margin-right: 0;
}
.close-popup {
  position: absolute;
  top: 0;
  right: 0;
  padding: 15px;
  font-size: 24px;
  line-height: 100%;
  z-index: 3;
  cursor: pointer;
  color: #FFF;
  text-shadow: 1px 1px 5px rgba(0,0,0,0.2);
}
#js-carousel-productgroup .item {
  min-height: 200px;
  max-height: 500px;
  height: 40vw;
}
.tags {
  display: flex;
  justify-content: center;
  gap: 15px;
}
.label.tag {
  font-size: 18px;
}
</style>

<script>
import sanitizeHtml from '~/lib/sanitizehtml'
import { ProductMovie, ProductGeneral, ProductProperties, ProductConnections, ProductDistances, ProductEnquiries, PopupProductItem } from '#components'

export default {
  data () {
    return {
      SUBTYPE_EVENT: 4,
      upsellProducts: [],
      upsellProductsLoaded: false,
      upsellProductsLoading: false
    }
  },
  props: ['product', 'shopId', 'productShopId', 'baseDomain', 'locale', 'hideMerchant', 'context', 'settings', 'showLinkedProducts'],
  computed: {
    tags () {
      let tagNames = []
      if (this.settings && this.product && this.product.sharedTag && this.product.sharedTag.length) {
        let tagArray = this.product.sharedTag
        for (let i = 0; i < tagArray.length; i++) {
          let defaultTagParts = tagArray[i].title.split(':::')
          let tagParts = tagArray[i].title.split(':::' + this.locale + ':::') 
          if (this.locale === this.settings.defaultversion && defaultTagParts.length === 2 && defaultTagParts[0] === 'product') {
            tagNames.push(defaultTagParts[1])
          } else if(tagParts.length == 2 && tagParts[0] === 'product') {
            tagNames.push(tagParts[1]) 
          }
        }
      }
      return tagNames
    },
    upsellTitle () {
      return this.settings.upselltitle || this._('Also recommended')
    },
    showFooter () {
      return !!this.context
    },
    hasCoordinates () {
      return this.product && this.product.channeldata && parseFloat(this.product.channeldata.latitude) && parseFloat(this.product.channeldata.longitude)
    },
    titleBelowImage () {
      return false
    },
    isEvent () {
      return parseInt(this.product.subtype) === this.SUBTYPE_EVENT
    },
    isMovie () {
      return parseInt(this.product.subtype) === this.SUBTYPE_EVENT && this.product.displayedtype === 'movie'
    },
    isOpera () {
      return parseInt(this.product.subtype) === this.SUBTYPE_EVENT && this.product.displayedtype === 'opera'
    },
    isTheater () {
      return parseInt(this.product.subtype) === this.SUBTYPE_EVENT && this.product.displayedtype === 'theater'
    },
    isBallet () {
      return parseInt(this.product.subtype) === this.SUBTYPE_EVENT && this.product.displayedtype === 'ballet'
    },
    isConcert () {
      return parseInt(this.product.subtype) === this.SUBTYPE_EVENT && this.product.displayedtype === 'ballet'
    },
    isMovieLike () {
      return (this.isMovie || this.isOpera || this.isTheater || this.isBallet)
    },
    previewProductUrl() {
      return 'https://' + this.shopId +'.johku.com/' + this.locale + '/' + this.product.canonical
    },
    allRatings () {
      let ratings = []
      let agelimit = 0
      if (this.product.channeldata && this.product.channeldata.agelimit) {
        switch (this.product.channeldata.agelimit) {
          case 'K-3':
          case 'S':
          case 'K-S':
          case 'K3':
            agelimit = 3
            break
          case '7':
          case 'K-7':
          case 'K7':
            agelimit = 7
            break
          case 'K-12':
          case '12':
          case 'K12':
            agelimit = 12
            break
          case 'K-16':
          case '16':
          case 'K16':
            agelimit = 16
            break
          case 'K-18':
          case '18':
          case 'K18':
            agelimit = 18
            break
        }
      }
      if (agelimit > 0) {
        ratings.push(agelimit.toString())
      } else {
        // ratings.push('unknown')
      }
      if (this.product.channeldata && this.product.channeldata.attributes) {
        for (var prop in this.product.channeldata.attributes) {
          switch (prop) {
            case 'drugs':
              ratings.push('drugs')
              break
            case 'violent':
              ratings.push('violence')
              break
            case 'sexual':
              ratings.push('sex')
              break
            case 'disturbing':
              ratings.push('horror')
              break
          }
        }
      }
      return ratings
    },
    hasTrailer () {
      return this.product.channeldata && this.product.channeldata.trailerurl && this.product.channeldata.trailerurl.indexOf('http') > -1
    },
    trailerUrl () {
      return this.product.channeldata.trailerurl
    }
  },
  methods: {
    sanitizeHtml,
    async loadUpsellProducts () {
      if (this.upsellProductsLoaded || this.upsellProductsLoading) {
        return
      }
      if (!this.product || !this.product.ownLinkedproduct || !this.product.ownLinkedproduct.length) {
        this.upsellProducts = []
        return
      }
      this.upsellProductsLoading = true
      let urlArray = []
      let doneIds = []
      for (var i = 0; i < this.product.ownLinkedproduct.length; i++) {
        if (parseInt(this.product.ownLinkedproduct[i].type, 10) === 1 && doneIds.indexOf(this.product.ownLinkedproduct[i].linkedproduct_id) === -1) {
          doneIds.push(this.product.ownLinkedproduct[i].linkedproduct_id)
          urlArray.push(this.baseDomain + this.productShopId + '/products/' + this.product.ownLinkedproduct[i].linkedproduct_id + '.json?version=' + this.locale)
        }
      }
      const datas = await Promise.all(urlArray.map(async url => {
        const resp = await fetch(url)
        return resp.json()
      }))

      let ret = []

      datas.forEach((p) => {
        if (p && p.enable_catalog && (parseInt(p.enable_catalog, 10) || p.enable_catalog.indexOf(this.locale) > -1)) {
          ret.push({
            id: p.id,
            source_id: p.id,
            name: p.usemarketingname && parseInt(p.usemarketingname) && p.marketingname ? p.marketingname : p.name,
            type: p.type,
            shopid: this.shopId,
            product: p
          })
        }
      })
      this.upsellProductsLoading = false
      this.upsellProductsLoaded = true
      this.upsellProducts = ret
    },
    closePopup () {
      this.$emit('close')
    },
    triggerAction () {
      this.$emit('action')
    },
    upsellProductClick (id) {
      this.$emit('linkedProductClick', id)
    }
  },
  updated() {
    if(this.product && (this.product.id != this.lastProductId || !this.lastProductId) && !!this.showLinkedProducts) {
      this.lastProductId = this.product.id
      this.upsellProducts = []
      this.loadUpsellProducts()
    }
  },
  created() {
    if(this.showLinkedProducts) {
      this.lastProductId = this.product.id
      this.upsellProducts = []
      this.loadUpsellProducts()
    }
  },
  components: {
    ProductMovie,
    ProductGeneral,
    ProductProperties,
    ProductConnections,
    ProductDistances,
    ProductEnquiries,
    PopupProductItem
  }
}
</script>
